<div class="resetpasswords">
    <form (ngSubmit)="onSubmit()" #resetPasswordForm="ngForm">
         <div class="col-md-6 col-lg-5 d-none d-md-block triangle">
              <img src="../../assets/logo/image (2).png" alt="login form" class="img-fluid" />
            </div>
      <div>
        <label for="email">Email:</label>
        <input type="email" id="email" name="email" [(ngModel)]="resetPasswordData.email" required email>
      </div>
  
      <div>
        <label for="password">Password:</label>
        <div style="position: relative;">
          <input [type]="showPassword ? 'text' : 'password'" id="password" name="password" [(ngModel)]="resetPasswordData.password" required minlength="6" pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$">
          <button type="button" (click)="togglePasswordVisibility('password')" style="position: absolute; right: 2px; top: 1px;  border: none; cursor: pointer;">
            <i class="fa" [ngClass]="showPassword ? 'fa-eye' : 'fa-eye-slash'"></i>
          </button>
        </div>
      </div>
  
      <div>
        <label for="confirmPassword">Confirm Password:</label>
        <div style="position: relative;">
          <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword" name="confirmPassword" [(ngModel)]="resetPasswordData.confirmPassword" required>
          <button type="button" (click)="togglePasswordVisibility('confirmPassword')" style="position: absolute; right: 2px; top: 1px;  border: none; cursor: pointer;">
            <i class="fa" [ngClass]="showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'"></i>
          </button>
        </div>
      </div>
  
      <div *ngIf="resetPasswordData.password !== resetPasswordData.confirmPassword && resetPasswordForm.submitted">
        <p style="color: red;">Passwords do not match.</p>
      </div>
  
      <button type="submit">Reset Password</button>
    </form>
  </div>